export default __webpack_public_path__ + "static/media/learose4-2048w.6734d159.png";